import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'

import '../assets/scss/main.scss'

import Header from '../components/header'
import Footer from '../components/footer'

const Layout = ({ children, location }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
        wp {
          siteOptions {
            acf {
              footer {
                seo
                address
                email
                linkedin
                instagram
                menu {
                  text
                  link
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      return (
        <>
          <Header />
          <main>{ children }</main>
          <Footer data={data} />
        </>
      )
    }
    }
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
